import BaseAPI from './base';

export const RestRequest = new BaseAPI();
